// extracted by mini-css-extract-plugin
export default {"labelRequired":"LabelRequired_labelRequired__rrhsp"};